import mixin from "@/mixin/index.js";
var fixed_database = require('../../public/database.json');
var sqlite_db = null;

document.addEventListener('deviceready', function () {
    sqlite_db = window.sqlitePlugin.openDatabase(
        {
            name: 'db_vetalfa',
            location: 'default',
            androidDatabaseProvider: 'system'
        },
        opened_db => {
            opened_db.transaction(
                tx => {
                    console.log("Creating tables....")
                    tx.executeSql('CREATE TABLE IF NOT EXISTS configuration (id, value)');
                    tx.executeSql('CREATE UNIQUE INDEX IF NOT EXISTS idx_configuration ON configuration (id)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS drugs (id, value)');
                    tx.executeSql('CREATE UNIQUE INDEX IF NOT EXISTS idx_drugs ON drugs (id)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS products (id, value)');
                    tx.executeSql('CREATE UNIQUE INDEX IF NOT EXISTS idx_products ON products (id)');
                },
                e => { console.log(`Error creating database: ${e.message}`) },
                _ => { console.log(`Database created`); });
        }
    );
    window.screen.orientation.lock('portrait');
});

const getUserFromStorage = (successCb, errorCb) => {
    if (mixin.methods._isCordovaApp()) {
        if (!sqlite_db || !sqlite_db.dbname || sqlite_db.dbname != "db_vetalfa") {
            return setTimeout(_ => { getUserFromStorage(successCb, errorCb) }, 100);
        } else {
            sqlite_db.executeSql('SELECT value AS value FROM configuration WHERE id = ?', ["user"], function (rs) {
                if (rs.rows.length) {
                    return successCb(mixin.methods._decrypt(rs.rows.item(0).value));
                } else {
                    return errorCb("User not found");
                }
            }, function (error) {
                return errorCb("User not found:" + error.message);
            });
        }
    } else {
        let user = window.localStorage.getItem("vetalfa");
        if (user) {
            try {
                user = JSON.parse(window.atob(user));
                window.localStorage.removeItem("vetalfa");
                window.localStorage.setItem("vetalfa", mixin.methods._encrypt(user));
                return successCb(user);
            } catch {
                return successCb(mixin.methods._decrypt(user));
            }
        }
        return errorCb("User not found");
    }
}

const readFromStaticDb = function (entity, id) {
    var result = fixed_database[entity];
    if (id) {
        result = result.find(e => {
            return mixin.methods._createIdentifier(e.id) === mixin.methods._createIdentifier(id);
        }).value;
    }
    if (result) {
        try {
            return JSON.parse(mixin.methods._decrypt(result));
        } catch {
            return mixin.methods._decrypt(result);
        }
    }
}

const selectAsync = async (entity, id) => {
    return new Promise((resolve, reject) => {
        var table = id ? entity : "configuration";
        sqlite_db.executeSql(`SELECT value AS value FROM ${table} WHERE id = ?`, [id || entity], (rs) => {
            resolve(rs);
        }, reject);
    });
}

const storageSelect = async (entity, id) => {
    if (mixin.methods._isCordovaApp()) {
        try {
            if (entity != "version" && !entity.includes("user")) {
                throw new Error('Using fixed DB.');
            }
            var rs = await selectAsync(entity, id);
            if (rs.rows.length) {
                return mixin.methods._decrypt(rs.rows.item(0).value);
            } else {
                return readFromStaticDb(entity, id);
            }

        } catch {
            return readFromStaticDb(entity, id);
        }
    } else if (entity == "user") {
        var user = window.localStorage.getItem("vetalfa");
        if (user) return mixin.methods._decrypt(user);
    }
    throw new Error(`Entity not found:${id ? `${entity}_${id}` : entity}`);
}

const storageDeleteWithId = (entity, id, successCb, errorCb) => {
    if (mixin.methods._isCordovaApp()) {
        var table = id ? entity : "configuration";
        id = id || entity;
        return sqlite_db.executeSql(`DELETE FROM ${table} WHERE id = ?`, [id], successCb,
            error => { errorCb("Error deleting entity:" + error.message); }
        );
    } else if (entity == "user") {
        window.localStorage.removeItem("vetalfa");
        return successCb();
    }
    return errorCb(`Entity not found:${id ? `${entity}_${id}` : entity}`);
}

const storageUpsert = (entity, id, document, successCb, errorCb) => {
    if (mixin.methods._isCordovaApp()) {
        var table = id ? entity : "configuration";
        id = id || entity;
        return sqlite_db.executeSql(`INSERT OR REPLACE INTO ${table} (id, value) VALUES (?1,?2)`, [id, mixin.methods._encrypt(document)],
            successCb,
            error => { errorCb("Error upserting entity:" + error.message); }
        );
    } else if (entity == "user") {
        window.localStorage.removeItem("vetalfa");
        window.localStorage.setItem("vetalfa", mixin.methods._encrypt(document));
        return successCb();
    }
    return errorCb(`Entity not found:${id ? `${entity}_${id}` : entity}`);
}

export default {
    storageUpsert,
    storageDeleteWithId,
    storageSelect,
    getUserFromStorage,
}